import dkAxios from '@/jslib/dk-axios'

export const getGroupList = data => dkAxios({
  url: '/v1/cms/Group',
  method: 'GET',
  params: data,
});

export const getAdminLog = data => dkAxios({
  url: '/v1/cms/AdminLog',
  method: 'GET',
  params: data,
});

export const getMenuBar = () => dkAxios({
  url: '/v1/cms/MenuBar',
  method: 'GET',
});

export const getGroupPermissionDetail = data => dkAxios({
  url: '/v1/cms/GroupPermission',
  method: 'GET',
  params: data,
});


export const delGroup = data => dkAxios({
  url: `/v1/cms/Group/${data}`,
  method: 'DELETE',
});


export const addGroup = data => dkAxios({
  url: '/v1/cms/Group',
  method: 'POST',
  data,
});


export const editGroup = data => dkAxios({
  url: `/v1/cms/Group/${data.uuid}`,
  method: 'PUT',
  data,
});


export const getAdminList = data => dkAxios({
  url: '/v1/cms/Admin',
  method: 'GET',
  params: data,
});

export const getAdminDetail = data => dkAxios({
  url: `/v1/cms/Admin/${data}`,
  method: 'GET',
});


export const addAdmin = data => dkAxios({
  url: '/v1/cms/Admin',
  method: 'POST',
  data,
});


export const editAdmin = data => dkAxios({
  url: `/v1/cms/Admin/${data.uuid}`,
  method: 'PUT',
  data,
});


export const deleteAdmin = data => dkAxios({
  url: `/v1/cms/Admin/${data}`,
  method: 'DELETE',
});



// WEBPACK FOOTER //
// ./src/api/system.js